import { createContext, useContext, useEffect } from "react";
/** The kiosk shell provides this; steps report whether an option sheet / popup is open (QA-079). */
export const DineSheetOpenContext = createContext(() => { });
/** Report an open sheet to the shell for as long as `open` is true. */
export function useReportSheetOpen(open) {
    const report = useContext(DineSheetOpenContext);
    useEffect(() => {
        if (!open)
            return;
        report(true);
        return () => report(false);
    }, [open, report]);
}
//# sourceMappingURL=sheetOpen.js.map